<div class="opt-hint"><ng-content></ng-content></div>
